import handleTransitionProps from './handle-transition-props';
import handleParallaxCache from './handle-parallax-cache';

function handlePageTransition(parallaxController, transitionStatus) {
  handleParallaxCache(parallaxController, transitionStatus);
  handleTransitionProps(transitionStatus);
}

export default handlePageTransition;
